// The env-driven (Doppler-sourced) portion of the app config. Each value reads a
// process.env.EXPO_PUBLIC_* var as a direct static member access so that
// babel-preset-expo (native) and next.config.js (web) inline it into the bundle
// at build time. Values are injected per-environment by Doppler — see doppler.yaml
// and the `doppler run` wrappers in package.json / CI.
//
// Build identity is NOT here (see ./identity.js). Missing vars surface as a zod
// error in ./bootstrap.js rather than being silently defaulted.

const bool = (v) => (v === undefined ? undefined : v === 'true');
const list = (v) =>
    v === undefined
        ? undefined
        : v
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean);

function fromEnv() {
    return {
        apiBaseUrl: process.env.EXPO_PUBLIC_API_BASE_URL,
        applePayMerchandId: process.env.EXPO_PUBLIC_APPLE_PAY_MERCHANT_ID,
        googleServicesAndroid: process.env.EXPO_PUBLIC_GOOGLE_SERVICES_ANDROID,
        googleServicesIos: process.env.EXPO_PUBLIC_GOOGLE_SERVICES_IOS,
        googleTagManagerId: process.env.EXPO_PUBLIC_GOOGLE_TAG_MANAGER_ID,
        firebaseCloudMessagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_CLOUD_MESSAGING_SENDER_ID,
        googleOauthClientIdWeb: process.env.EXPO_PUBLIC_GOOGLE_OAUTH_CLIENT_ID_WEB,
        googleOauthClientIdIos: process.env.EXPO_PUBLIC_GOOGLE_OAUTH_CLIENT_ID_IOS,
        googleOauthClientIdAndroid: process.env.EXPO_PUBLIC_GOOGLE_OAUTH_CLIENT_ID_ANDROID,
        googleOauthiOSUrlScheme: process.env.EXPO_PUBLIC_GOOGLE_OAUTH_IOS_URL_SCHEME,
        appleOauthClientIdWeb: process.env.EXPO_PUBLIC_APPLE_OAUTH_CLIENT_ID_WEB,
        appleOauthRedirectUri: process.env.EXPO_PUBLIC_APPLE_OAUTH_REDIRECT_URI,
        hCaptchaSiteKeyWeb: process.env.EXPO_PUBLIC_HCAPTCHA_SITE_KEY_WEB,
        hCaptchaSiteKeyNative: process.env.EXPO_PUBLIC_HCAPTCHA_SITE_KEY_NATIVE,
        sentryDsnNative: process.env.EXPO_PUBLIC_SENTRY_DSN_NATIVE,
        sentryDsnWeb: process.env.EXPO_PUBLIC_SENTRY_DSN_WEB,
        sentryEnvironment: process.env.EXPO_PUBLIC_SENTRY_ENVIRONMENT,
        sentryDebug: bool(process.env.EXPO_PUBLIC_SENTRY_DEBUG),
        postHogApiKey: process.env.EXPO_PUBLIC_POSTHOG_API_KEY,
        iterableApiKey: process.env.EXPO_PUBLIC_ITERABLE_API_KEY,
        stateStorageKey: process.env.EXPO_PUBLIC_STATE_STORAGE_KEY,
        cloudinaryCloudName: process.env.EXPO_PUBLIC_CLOUDINARY_CLOUD_NAME,
        e2eTesting: bool(process.env.EXPO_PUBLIC_E2E_TESTING),
        useFixtures: bool(process.env.EXPO_PUBLIC_USE_FIXTURES),
        universalLinkDomains: list(process.env.EXPO_PUBLIC_UNIVERSAL_LINK_DOMAINS),
        oneSignalAppId: process.env.EXPO_PUBLIC_ONESIGNAL_APP_ID,
        brazeConfig: {
            androidApiKey: process.env.EXPO_PUBLIC_BRAZE_ANDROID_API_KEY,
            iosApiKey: process.env.EXPO_PUBLIC_BRAZE_IOS_API_KEY,
            webApiKey: process.env.EXPO_PUBLIC_BRAZE_WEB_API_KEY,
            baseUrl: process.env.EXPO_PUBLIC_BRAZE_BASE_URL,
            enableLogging: bool(process.env.EXPO_PUBLIC_BRAZE_ENABLE_LOGGING)
        },
        azureInsights: {
            web: process.env.EXPO_PUBLIC_AZURE_INSIGHTS_WEB,
            native: process.env.EXPO_PUBLIC_AZURE_INSIGHTS_NATIVE
        },
        mapboxApiKeyNative: process.env.EXPO_PUBLIC_MAPBOX_API_KEY_NATIVE,
        mapboxApiKeyWeb: process.env.EXPO_PUBLIC_MAPBOX_API_KEY_WEB,
        mixpanelToken: process.env.EXPO_PUBLIC_MIXPANEL_TOKEN,
        roktIosKey: process.env.EXPO_PUBLIC_ROKT_IOS_KEY,
        roktIosSecret: process.env.EXPO_PUBLIC_ROKT_IOS_SECRET,
        roktAndroidKey: process.env.EXPO_PUBLIC_ROKT_ANDROID_KEY,
        roktAndroidSecret: process.env.EXPO_PUBLIC_ROKT_ANDROID_SECRET,
        roktWebApiKey: process.env.EXPO_PUBLIC_ROKT_WEB_API_KEY,
        // StackAdapt conversion pixels for Optimal (JSAD-7304) — web only, set on prd only
        stackadaptOrderNowPixelId: process.env.EXPO_PUBLIC_STACKADAPT_ORDER_NOW_PIXEL_ID,
        stackadaptPurchasePixelId: process.env.EXPO_PUBLIC_STACKADAPT_PURCHASE_PIXEL_ID,
        iosAppStoreUrl: process.env.EXPO_PUBLIC_IOS_APP_STORE_URL,
        androidPlayStoreUrl: process.env.EXPO_PUBLIC_ANDROID_PLAY_STORE_URL
    };
}

module.exports = fromEnv;
